export default __webpack_public_path__ + "static/builderSectionBg-458ab7970c7612cb30318a6108014bc5.png";